/**
 * Get a string divided by spaces from a camelCase string
 * @param {string} stringToFormat
 */
const formatCamelCaseToSpaceSeparateWords = (stringToFormat) => {
    return stringToFormat
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .toLocaleLowerCase();
};
export default formatCamelCaseToSpaceSeparateWords;
